{
  "version": 1,
  "asset_id": "93c2dcf1-73f6-499a-911c-25dc4dcc5fca",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/93c2dcf1-73f6-499a-911c-25dc4dcc5fca/egg-rocky.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/93c2dcf1-73f6-499a-911c-25dc4dcc5fca/egg-rocky.webp",
  "original_filename": "egg-rocky.webp",
  "size": 6382,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:54:17Z"
}
